import { render, staticRenderFns } from "./KycCompanyDocument.vue?vue&type=template&id=56a294e0&scoped=true"
import script from "./KycCompanyDocument.vue?vue&type=script&lang=js"
export * from "./KycCompanyDocument.vue?vue&type=script&lang=js"
import style0 from "./KycCompanyDocument.vue?vue&type=style&index=0&id=56a294e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a294e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a294e0')) {
      api.createRecord('56a294e0', component.options)
    } else {
      api.reload('56a294e0', component.options)
    }
    module.hot.accept("./KycCompanyDocument.vue?vue&type=template&id=56a294e0&scoped=true", function () {
      api.rerender('56a294e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/kyc/KycCompanyDocument.vue"
export default component.exports